import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { usePartner } from 'components/app/routes/usePartner';
import { NsAlert } from 'components/common/ns-alert/NsAlert';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';
import { setShowPrompt } from 'state/settings/settings-slice';
import { actionUrl } from 'config/static-content';

export const testId = 'sessionErrorTestId';

type SessionErrorProps = {
  message?: string
  title?: string
};

export const SessionError = ({ message, title }: SessionErrorProps) => {
  const dispatch = useDispatch();
  const { isDSJourney } = usePartner();

  const handleBackToQuote = () => {
    window.location.reload();
  };

  useEffect(() => {
    // Disable data loss user prompt.
    // The only way to recover from session expiration is refreshing the page
    // so there is no point in prompting the user about data loss
    dispatch(setShowPrompt(false));
  });

  return (
    <NsAlert state="error" heading={title} testId={testId}>
      <p>{message}</p>
      {isDSJourney ? (
        <NsSecondaryCta onClick={handleBackToQuote}>
          Back to get a quote
        </NsSecondaryCta>
      ) : (
        <NsSecondaryCta href={actionUrl.bgHome} target="_self">
          Go to homepage
        </NsSecondaryCta>
      )}
    </NsAlert>
  );
};
